import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import ClickSpark from '@ui/components/vendor/react-bits/ClickSpark/ClickSpark';
import { microBrand } from './brand';
import { prefersReducedMotion } from './reducedMotion';
import './success-spark.scss';
let activeLayer = null;
const anchorCentre = (anchor) => {
    const focused = document.activeElement;
    const candidate = anchor ?? (focused instanceof HTMLElement && focused !== document.body ? focused : null);
    if (candidate) {
        const rect = candidate.getBoundingClientRect();
        if (rect.width > 0 || rect.height > 0) {
            return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
        }
    }
    return { x: window.innerWidth / 2, y: window.innerHeight / 2 };
};
/**
 * Fire the React Bits Click Spark as success feedback, centred on `anchor`, else the focused element,
 * else the viewport. Decoration only: it never throws and does nothing with reduced motion.
 */
export const burstSuccessSpark = (anchor) => {
    if (!activeLayer || prefersReducedMotion())
        return;
    try {
        const { x, y } = anchorCentre(anchor);
        activeLayer.burst(x, y);
    }
    catch {
        // Decoration must never interfere with the flow that called it.
    }
};
/** One fixed, click-through canvas layer above the loader overlay. Mount once, at the app root. */
export const SuccessSparkLayer = () => {
    const ref = useRef(null);
    useEffect(() => {
        const handle = ref.current;
        activeLayer = handle;
        return () => {
            if (activeLayer === handle)
                activeLayer = null;
        };
    }, []);
    return (_jsx("div", { className: 'success-spark-layer', "aria-hidden": 'true', children: _jsx(ClickSpark, { ref: ref, sparkOnClick: false, sparkColor: microBrand.sparkColors, sparkSize: 14, sparkRadius: 34, sparkCount: 12, duration: 560, lineWidth: 2.5 }) }));
};
